import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const FIELDS = [['name', 'Full legal name of BETH entity'], ['entity_type', 'State and entity type (e.g. Delaware limited liability company)'],
  ['address', 'Principal business address'], ['governing_law', 'Governing law state'], ['signatory', 'Authorized signatory'],
  ['signatory_title', 'Signatory title'], ['initials', 'Authorized initials']];

export const AdminLegalEntity = ({ token }) => {
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  const auth = { headers: { Authorization: `Bearer ${token}` } };
  useEffect(() => { axios.get(`${API}/pas-ledger/admin/legal-entity`, { headers: { Authorization: `Bearer ${token}` } }).then(r => setF(r.data)).catch(() => setF({})); }, [token]);
  const save = async () => {
    setBusy(true);
    try { toast.success((await axios.put(`${API}/pas-ledger/admin/legal-entity`, f, auth)).data.message); }
    catch (err) { toast.error(err.response?.data?.detail || 'Save failed'); }
    finally { setBusy(false); }
  };
  if (!f) return null;
  return (
    <div className="bg-slate-800 border border-slate-700 rounded-xl p-6" data-testid="legal-entity-form">
      <h3 className="text-white font-semibold">Creditor details used in agreements</h3>
      <p className="text-xs text-slate-400 mb-4">Fills the BETH party, governing law and signature block of new agreements. Signed agreements keep the details in effect when signed.</p>
      <div className="grid sm:grid-cols-2 gap-3">
        {FIELDS.map(([k, label]) => (
          <label key={k} className="text-xs text-slate-400">{label}
            <input value={f[k] || ''} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`legal-entity-${k}`}
              className="mt-1 w-full bg-slate-900 border border-slate-600 rounded-lg px-3 py-2 text-white text-sm focus:border-emerald-500 outline-none" />
          </label>
        ))}
      </div>
      <button onClick={save} disabled={busy} data-testid="legal-entity-save-btn" className="mt-4 px-5 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg text-sm font-semibold disabled:opacity-40">{busy ? 'Saving...' : 'Save details'}</button>
    </div>
  );
};
